const originOf = (url?: string) => {
	try {
		return url ? new URL(url).origin : null;
	} catch {
		return null;
	}
};

/**
 * Admin's "log in as" opens the web app on the customer-login host, running on the token admin hands it. The API
 * sends that host no cookies, so in cookie mode every cookie request from it fails. Locally it is the app's own host.
 */
export const isCookieSessionEnabled = (origin = window.location.origin) => {
	if (import.meta.env.VITE_COOKIE_SESSION_WEB !== 'true') {
		return false;
	}

	const customerLoginOrigin = originOf(import.meta.env.VITE_CUSTOMER_APP_URL);
	return (
		!customerLoginOrigin ||
		customerLoginOrigin === originOf(import.meta.env.VITE_APP_URL) ||
		origin !== customerLoginOrigin
	);
};
